import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// 🔹 Thunk for fetching device raw data
export const fetchHeatData = createAsyncThunk(
  "heat/fetchHeatData",
  async (searchTerm, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `https://v3.dhundhoo.com/device/rawdata/${searchTerm}`,
        {
          headers: {
            "x-dhundhoo-session": token,
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error fetching heat data"
      );
    }
  }
);

// 🔹 Thunk for fetching device config/details
export const fetchHeatDetails = createAsyncThunk(
  "heat/fetchHeatDetails",
  async (searchTerm, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `https://v3.dhundhoo.com/superAdmin/getDeviceConfig/${searchTerm}`,
        {
          headers: {
            "x-dhundhoo-session": token,
          },
        }
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error fetching heat details"
      );
    }
  }
);
